module.exports = __webpack_public_path__ + "img/logo_color.d1c190f9.svg";